import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="image-click"
// Attach to body or content wrapper to handle image clicks and img-fluid
export default class extends Controller {
  connect() {
    this.addImgFluid()
  }

  openImage(event) {
    if (event.target.tagName === 'IMG') {
      const container = event.target.closest('.tw-rich, .ticket-content, .post-body, .card-text, .priv-body, .res-body')
      if (container) {
        window.open(event.target.src, '_blank')
      }
    }
  }

  addImgFluid() {
    this.element.querySelectorAll('.post-body img, .card-text img, .res-body img').forEach(img => {
      img.classList.add('img-fluid')
    })
  }
}
